<template>
  <Dialog :open="open" @close="$emit('close')" width="720px">
    <template v-slot:title>
      <FlexRow full-width justify="center">
        新規リスト作成
      </FlexRow>
    </template>
    <template v-slot:default>
      <TextField
          v-model="name"
          name="リスト名"
          max="100"
          :rules="listNameRules"
      />
    </template>
    <template v-slot:actions>
      <FlexRow full-width justify="center">
        <TextButton
            :primary="enableCreateButton"
            :disabled="!enableCreateButton"
            @click="handleCreate"
        >
          リストを作成する
        </TextButton>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import FlexRow from "@/components/atoms/FlexRow";
import Dialog from "@/components/atoms/Dialog";
import TextField from "@/components/atoms/TextField";
import TextButton from "@/components/atoms/TextButton";
import ApiMixin from "@/ApiMixin";
import {mapGetters} from "vuex";
export default {
  mixins: [ApiMixin],
  name: "ApplicantListSaveDialog",
  components: {TextButton, TextField, Dialog, FlexRow},
  props: {
    open: {
      type: Boolean
    }
  },
  data() {
    return {
      name: undefined
    }
  },
  computed: {
    ...mapGetters("client", ["company"]),
    ...mapGetters("chatRequests", ["lists"]),
    listNameRules() {
      return [
          value => {
            return this.validateListName(value)
          }
      ]
    },
    enableCreateButton() {
      if (this.name === undefined || this.name === "") {
        return false
      }
      return this.validateListName(this.name) === true
    }
  },
  methods: {
    validateListName(name) {
      if (name === "お気に入り" || name === "非表示") {
        return "使用できないリスト名です"
      }
      if (this.lists.map(list => list.name).includes(name)) {
        return "同名のリストが存在します"
      }
      return true
    },
    handleCreate() {
      this.createChatRequestList(this.company.id, this.name)
      this.name = undefined
      this.$emit("close")
    }
  }
}
</script>

<style scoped>

</style>